export const EMPRESA_OPTIONS = [
  { value: "stage", label: "Stage" },
  { value: "erna", label: "ERNA" },
  { value: "fusion", label: "Fusión" },
];

export const MESES_OPTIONS = [
  { value: 1, label: "Ene" },
  { value: 2, label: "Feb" },
  { value: 3, label: "Mar" },
  { value: 4, label: "Abr" },
  { value: 5, label: "May" },
  { value: 6, label: "Jun" },
  { value: 7, label: "Jul" },
  { value: 8, label: "Ago" },
  { value: 9, label: "Sep" },
  { value: 10, label: "Oct" },
  { value: 11, label: "Nov" },
  { value: 12, label: "Dic" },
];

export const SEVERIDAD_META = {
  critica: { label: "Crítica", color: "error" },
  alta: { label: "Alta", color: "warning" },
  media: { label: "Media", color: "info" },
  info: { label: "Info", color: "default" },
};

export const resolveAlertLink = (alerta, empresa) => {
  if (alerta?.enlace) return alerta.enlace;
  const emp = empresa || "stage";
  return `/insights/${emp}`;
};
